module.exports = __webpack_public_path__ + "static/pcrc-6ea884869d0ce861e3d94c6ea301e54f.jpg";